import PostOrder from '@/language/es/components/post/PostOrder';

export default {
  PostOrder,
};
